import Modal from './Modal';

import './styles/style.scss';

export default Modal;



// WEBPACK FOOTER //
// ./src/components/Modal/index.js